var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-footer"},[_c('span',{staticClass:"footer-text",staticStyle:{"margin-right":"5px"}},[_c('strong',[_vm._v("Copyright © 2021 Tống Đạt.")]),_vm._v(" All rights reserved.")])])
}]

export { render, staticRenderFns }